import React from 'react';
import * as Icons from 'solar-icon-set';
import { useModal } from '../export';
import Button from '../../../grapes/atoms/button/Button';
import { useWidget } from '../../widget/export';
import { useResources } from '../../project/resources/export';

const ModalHeader = () => {

    const modal = useModal()

    return (
        <div className="flex w-full justify-end items-center">
            <div className='gap-x-2 flex'>
            </div>
            <button className='cursor-pointer px-2 py-2'>
                <Icons.CloseCircle iconStyle='Bold' size={24} onClick={() => {
                    modal.actions.reset()
                }} />
            </button>
        </div>
    );
};

export default ModalHeader;

